export default {
  name: "componentsDiscountCoupon",

  props: {
    data: Array,
    visible: Boolean,
  },

  methods: {
    close() {
      this.visible = false;
    },
  },
};
